import * as React from "react";
import { IconBusiness, IconFilledHome, IconManageAccounts, IconSetting } from "@/assets/icons";
import { AppRoutes, OrganizationRoutes } from "@/routes/config";
import { TUserType } from "@/types/enum";

export type TMenuItemChild = {
  text: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  path: string;
  relatedRoutes: string[];
};

export type TMenuSection = {
  text: string;
  children: TMenuItemChild[];
};

export type TMenuItem = TMenuItemChild | TMenuSection;

const homeMenu: TMenuItemChild = {
  text: "ホーム",
  icon: IconFilledHome,
  path: AppRoutes.home,
  relatedRoutes: [AppRoutes.home],
};

/** 取引先 — 一覧はまだ無いので登録画面(ACC20C02)を入口にする。 */
const companyMenu: TMenuItemChild = {
  text: "取引先",
  icon: IconBusiness,
  path: AppRoutes.companyCreate,
  relatedRoutes: [AppRoutes.companyCreate],
};

const salesManagementMenuSection: TMenuSection = {
  text: "販売管理",
  children: [companyMenu],
};

const organizationSettingMenu: TMenuItemChild = {
  text: "組織設定",
  icon: IconSetting,
  path: AppRoutes.organizationBusiness,
  relatedRoutes: OrganizationRoutes,
};

const userSettingMenu: TMenuItemChild = {
  text: "ユーザー設定",
  icon: IconManageAccounts,
  path: AppRoutes.userSettingDetail,
  relatedRoutes: [AppRoutes.userSettingDetail, AppRoutes.userSettingEdit],
};

const settingMenuSection: TMenuSection = {
  text: "設定メニュー",
  children: [organizationSettingMenu, userSettingMenu],
};

export const getMenus = (userType?: TUserType, companyId?: number): TMenuItem[] => {
  if (!userType) return [];
  return [homeMenu, salesManagementMenuSection, settingMenuSection];
};
